import { Box, Typography, Chip } from "@mui/joy";

function NewsHeader({ website, category }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
      <Typography level="body-xs">{website}</Typography>
      <Chip
        size="sm"
        variant="soft"
        color="primary"
        sx={{ ml: 'auto' }}
      >
        {category}
      </Chip>
    </Box>
  );
}

export default NewsHeader;